import React from 'react'

import { PauseButton } from 'components/PauseButton'
import { LiveButton } from 'components/LiveButton'
import OneoffEmailSendButtonContainer from 'components/OneoffEmailSendButton/container'

/**
 *
 * @typedef Survey
 * @property {string} status
 * @property {'ongoing_email'|'oneoff_email'} type
 */

/**
 *
 * @param {object} props
 * @param {Survey} props.survey
 * @param {string} [props.className]
 * @param {boolean} props.isOngoingEmailLive
 * @param {boolean} props.loading
 * @param {() => void} props.onPauseSurvey
 * @param {(callback: function) => () => void} props.createOnSetSurveyLive
 */
export default function EmailSurveyHeaderActionButton({
  // @ts-ignore
  survey = {},
  className,
  isOngoingEmailLive,
  loading,
  onPauseSurvey,
  createOnSetSurveyLive,
}) {
  const isSurveyClosed =
    survey.is_closed_enabled &&
    survey.closed_at &&
    Date.now() >= new Date(survey.closed_at).getTime()

  if (['ongoing_email', 'NPS'].includes(survey.type)) {
    return (
      <OngoingEmailHeaderActionButton
        className={className}
        survey={survey}
        isOngoingEmailLive={isOngoingEmailLive}
        loading={loading}
        onPauseSurvey={onPauseSurvey}
        createOnSetSurveyLive={createOnSetSurveyLive}
        isSurveyClosed={isSurveyClosed}
      />
    )
  }

  if (survey.type === 'oneoff_email') {
    return <OneoffEmailSendButtonContainer className={className} isSurveyClosed={isSurveyClosed} />
  }

  return null
}

/**
 * @param {object} props
 * @param {Survey} props.survey
 * @param {string} [props.className]
 * @param {boolean} props.isOngoingEmailLive
 * @param {boolean} props.loading
 * @param {() => void} props.onPauseSurvey
 * @param {(callback: function) => () => void} props.createOnSetSurveyLive
 * @param {boolean} props.isSurveyClosed
 */
function OngoingEmailHeaderActionButton({
  className,
  survey,
  isOngoingEmailLive,
  loading,
  onPauseSurvey,
  createOnSetSurveyLive,
  isSurveyClosed,
}) {
  const isSurveyActive = survey.status === 'active'
  if (isOngoingEmailLive) {
    return (
      <PauseButton
        className={className}
        loading={loading}
        disabled={!isSurveyActive}
        onClick={onPauseSurvey}
      />
    )
  }

  return (
    <LiveButton
      className={className}
      loading={loading}
      isButtonDisabled={!isSurveyActive || isSurveyClosed}
      createOnSetSurveyLive={createOnSetSurveyLive}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/EmailSurveyHeaderActionButton/index.js